angular.module('leanlaw').factory('originationDetailDefinitionByMatter', ['$q', 'singleRequest', 'clientMatterManager', function ($q, singleRequest) {
  const cancel = params => {
    singleRequest.cancel('compensation');
  };
  const load = async ({
    query,
    params,
    filter
  }) => {
    const request = {
      ...query,
      primary: 'clients',
      data: 'payments',
      status: 'all',
      scope: params.userId ? 'originating' : '-originating',
      scopeAccount: params.userId
    };
    const report = await singleRequest.apiCall('compensation').getReport(request);

    // create rows and subrows for group of users and items
    const rows = [];
    report.clients.forEach(client => {
      client.matters.forEach(matter => {
        rows.push({
          id: matter.matter.id,
          clientId: client.client.id,
          matterId: matter.matter.id,
          label: matter.matter.label,
          values: {
            id: {
              value: matter.matter.reference
            },
            client: {
              value: client.client && client.client.name
            },
            matter: {
              value: matter.matter && matter.matter.name
            },
            services: {
              value: matter.data.collected.servicesTotal
            },
            expenses: {
              value: matter.data.collected.expensesTotal
            },
            total: {
              value: matter.data.collected.total
            },
            origination: {
              value: matter.data.origination.originatorDebit
            },
            percentage: {
              value: matter.data.origination.percentage
            }
          }
        });
      });
    });
    return {
      rows
    };
  };
  const filterChange = ({
    filter
  }) => {
    if (filter.originationUser) {
      return {
        navigate: {
          id: 'origination-detail-user'
        }
      };
    }
  };
  const structure = ({
    params,
    me
  }) => {
    return {
      sort: 'client',
      label: `Origination`,
      totals: {
        rows: true,
        totalLabelCells: 3
      },
      showFilters: {
        distribution: true,
        dateRange: true,
        originationUser: true
      },
      columns: [{
        id: 'id',
        label: 'Id'
      }, {
        id: 'client',
        label: 'Client'
      }, {
        id: 'matter',
        label: 'Matter'
      }, {
        id: 'services',
        label: 'Collected Services',
        filter: 'amount',
        number: true
      }, {
        id: 'expenses',
        label: 'Collected Expenses',
        filter: 'amount',
        number: true
      }, {
        id: 'total',
        label: 'Collected Total',
        filter: 'amount',
        number: true
      }, {
        id: 'origination',
        label: 'Origination',
        filter: 'amount',
        number: true
      }, {
        id: 'percentage',
        label: 'Percentage',
        filter: 'percentage',
        number: true,
        total: false
      }]
    };
  };
  return {
    structure,
    load,
    filterChange,
    cancel
  };
}]);